import { observable, action, makeObservable } from 'mobx';
import { BaseListViewStore, HyperLinkTrackingNumberCellData } from 'core/stores';
import { createFileUrl, notificationError } from 'core/utils';
import { ShipmentInfoStore } from 'modules/shipment-info/stores';
import _ from 'lodash';

class ReturnedItemsListViewStore extends BaseListViewStore {
	@observable change = false;
	@observable pdfURLReturn = null;
	@observable data = null;
	isExpand = true;
	noDataItem = true;

	constructor(rootStore, props) {
		super(rootStore, {
			listStore: new ShipmentInfoStore(rootStore),
			queryParams: {
				embed: [],
				filter: null,
				ignore: true,
			},
			findFunction: 'findShipmentInfoReturn',
			tableData: {
				columns: [
					{
						key: 'trackingNumber',
						title: 'RETURNEDITEMS.TRACKINGNUMBER',
						dataCell: HyperLinkTrackingNumberCellData,
						carrierTypePath: 'carrierService.carrierType.name',
						selected: true,
						width: 600,
						filter: null,
					},
					{
						key: 'returnReason.name',
						title: 'RETURNEDITEMS.RETURNREASON',
						selected: true,
						width: 400,
						filter: null,
					},
				],
				sortObject: [],
				actions: {
					onPrintReturnLabel: async item => this.getReturnLabelAndPrint(item),
				},
			},
			permissions: { onPrintReturnLabel: () => this.authStore.hasPermission('marketplaceOrderSection.read') },
			routes: {},
		});
		makeObservable(this);
		this.data = props.data; // props.data = Shipment Info Returns
	}

	@action.bound
	async findShipmentInfoReturn() {}

	@action.bound
	getReturnLabelAndPrint = async item => {
		try {
			await this.listStore.reprintLabel(item.id, true);
			if (this.listStore.item.data.label != null) {
				this.pdfURLReturn = createFileUrl(this.listStore.item.data.label);
				this.openPrintPdfReturnModal();
			} else {
				this.rootStore.notificationStore.error('FULFILLMENTORDER.LABELNOTFOUND');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	};

	@action.bound
	openPrintPdfReturnModal() {
		setTimeout(function() {
			const frame = window.frames['pdf-print-return'];
			this.printPdf = false;
			frame.print();
		}, 250);
	}

	@action.bound
	onExpandChange = event => {
		// this.data = Shipment Info Returns.
		const item = _.find(this.data, ({ id }) => id === event.dataItem.id);
		// Dynamically add "expanded" boolean property to the Shipment Info Return.
		item.expanded = !item.expanded;
		this.setAsChanged();
	};

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};
}

export default ReturnedItemsListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/ReturnedItemsListViewStore.js